window.I18n.translations.en.priceGuide = {
  searchBar: {
    placeholder: 'Brand, model, year ...'
  }
};



// WEBPACK FOOTER //
// ./javascripts/translations/price_guide/en.js